<template>
  <basic-container>
    <!-- 搜索区域 -->
    <div class="search-area">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline" size="small">
        <el-form-item>
          <el-date-picker v-model="searchForm.month" type="month" placeholder="请选择月份" value-format="yyyy-MM" clearable
            style="width: 130px;">
          </el-date-picker>
        </el-form-item>

        <!-- 日期范围 -->
        <el-form-item>
          <el-date-picker v-model="submitTime" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" :clearable="false"
            style="width: 250px;">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <DynamicOption v-model="searchForm.aid" :placeholder="'全部应用'" :singleSelect="true" :params="searchOptions" />
        </el-form-item>

        <el-form-item>
          <el-select v-model="searchForm.sdkv" placeholder="全部版本" clearable>
            <el-option v-for="item in versionList" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 全部产品类型 -->
        <el-form-item>
          <el-select v-model="searchForm.productId" placeholder="全部产品类型" clearable>
            <el-option v-for="item in clientTypes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchForm.manufacturer" placeholder="请输入厂商标志" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchForm.unitType" placeholder="请输入设备型号" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-input v-model="searchForm.chipName" placeholder="请输入芯片名称" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-input v-model="searchForm.sysv" placeholder="请输入系统版本号" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-input v-model="searchForm.appv" placeholder="请输入客户端版本号" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-input v-model="searchForm.uid" placeholder="请输入UID" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-input v-model="searchForm.roomid" placeholder="请输入会议ID" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-input v-model="searchForm.code" placeholder="请输入投屏码" clearable></el-input>
        </el-form-item>

        <!-- 第二行 -->
        <el-form-item>
          <el-input v-model="searchForm.hid" placeholder="请输入HID" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-input v-model="searchForm.cid" placeholder="发送端CID(IMEI或IDFA)" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-input v-model="searchForm.mac" placeholder="请输入MAC地址" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-input v-model="searchForm.pn" placeholder="请输入手机号码" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-input v-model="searchForm.euqid" placeholder="请输入双端关联ID" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="handleSearch">搜索</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <el-table :cell-style="{ 'text-align': 'center' }" :header-cell-style="{ 'text-align': 'center' }"
      :max-height="tableHeight" v-loading="listLoading" element-loading-text="加载中" border :data="tableData"
      :row-style="{ height: '30px' }">

      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="aid" label="应用名称" width="150">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.aid" placement="top">
            <span class="ellipsis-text">{{ scope.row.aid }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="sysv" label="系统版本" width="100"></el-table-column>
      <el-table-column prop="appv" label="客户端版本" width="120"></el-table-column>
      <el-table-column prop="roomid" label="会议id" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.roomid }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="投屏码" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ct" label="客户端类型" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.ct }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="上报时间" width="180"></el-table-column>
      <el-table-column prop="euqid" label="双端关联ID" width="200">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.euqid" placement="top">
            <span class="ellipsis-text">{{ scope.row.euqid }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="et" label="问题类型" width="100"></el-table-column>
      <el-table-column prop="manufacturer" label="厂商" width="120"></el-table-column>
      <el-table-column prop="unitType" label="设备型号" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.unitType" placement="top">
            <span class="ellipsis-text">{{ scope.row.unitType }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="chipName" label="芯片名称" width="180">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.chipName" placement="top">
            <span class="ellipsis-text">{{ scope.row.chipName }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="productName" label="产品类型" width="120"></el-table-column>
      <el-table-column prop="sdkv" label="SDK版本号" width="150">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.sdkv" placement="top">
            <span class="ellipsis-text">{{ scope.row.sdkv }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="UID" width="180">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.uid" placement="top">
            <span class="ellipsis-text">{{ scope.row.uid }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="hid" label="HID" width="200">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.hid" placement="top">
            <span class="ellipsis-text">{{ scope.row.hid }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="cid" label="CID" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.cid }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="mac" label="MAC" width="150">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.mac" placement="top">
            <span class="ellipsis-text">{{ scope.row.mac }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="context" label="问题描述" width="200">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.context" placement="top">
            <span class="ellipsis-text">{{ scope.row.context }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="video" label="视频链接" width="120">
        <template slot-scope="scope">
          <el-link v-if="scope.row.video" type="primary" :href="scope.row.video" target="_blank">查看视频</el-link>

        </template>
      </el-table-column>
      <el-table-column prop="images" label="图片链接" width="120">
        <template slot-scope="scope">
          <el-link v-if="scope.row.images" type="primary" :href="scope.row.images" target="_blank">查看图片</el-link>

        </template>
      </el-table-column>
      <el-table-column prop="pn" label="手机号" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.pn }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleDownload(scope.row)" v-if="scope.row.logfileurl">
            下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="table_pagination">
      <el-pagination class="app-pagination" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="pageSizeArr" :page-size="pageSize"
        :layout="paginationLayout" :total="totalCount">
      </el-pagination>
    </div>
  </basic-container>
</template>

<script>
import { getUserFeedBackList, getClientType, getEtList,getVersionListByChanelid } from '@/api/clientManageMent/userFeedBack'
import DynamicOption from "@/components/DynamicOption/index.vue";
export default {
  name: 'UserFeedBack',
  components: { DynamicOption },
  data() {
    return {
      // 搜索表单
      searchForm: {
        unitType: '',
        chipName: '',
        sysv: '',
        appv: '',
        uid: '',
        roomid: '',
        code: '',
        hid: '',
        cid: '',
        mac: '',
        pn: '',
        euqid: '',
        // 保留原有字段用于API调用
        aid: '',
        et: '',
        sdkv: '',
        productId: '',
        manufacturer: '',
        month: '',
        begindate: '',
        enddate: '',
      },
      submitTime: [],
      // 表格数据
      tableData: [],
      // 加载状态
      listLoading: false,
      tableHeight: 500,
      // 分页信息
      pageNo: 1,
      pageSize: 10,
      pageSizeArr: [10, 20, 50, 100],
      paginationLayout: 'total, sizes, prev, pager, next, jumper',
      totalCount: 0,
      // 日期选择器配置
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }],
        // 选择范围不能超过30天
        onPick: ({ minDate, maxDate }) => {
          this.pickerMinDate = minDate ? new Date(minDate) : null
          if (this.pickerMinDate && maxDate) {
            const diffDays = Math.floor((new Date(maxDate) - this.pickerMinDate) / (1000 * 60 * 60 * 24))
            if (diffDays > 30) {
              this.$message.warning('选择时间范围不能超过30天')
            }
          }
        },
        disabledDate: (time) => {
          if (!this.pickerMinDate) return false
          const min = new Date(this.pickerMinDate.getTime() - 30 * 24 * 60 * 60 * 1000)
          const max = new Date(this.pickerMinDate.getTime() + 30 * 24 * 60 * 60 * 1000)
          return time.getTime() < min.getTime() || time.getTime() > max.getTime()
        }
      },
      // 记录已选的首日
      pickerMinDate: null,
      clientTypes: [],
      etList: [],
      versionList: [],
    }
  },
  created() {
    // 设置默认时间为前七天到今天
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    this.submitTime = [
      this.formatDate(start),
      this.formatDate(end)
    ];

    this.getList()
    this.fetchClientTypes()
    this.fetchEtList()
    this.fetchVersionListByChanelid()
  },
  methods: {
    // 格式化日期为 yyyy-MM-dd 格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 获取列表数据
    async getList() {
      this.listLoading = true
      try {
        const params = {
          page: this.pageNo,
          limit: this.pageSize,
          ...this.searchForm
        }

        // 添加时间范围参数
        if (this.submitTime && this.submitTime.length === 2) {
          params.begindate = this.submitTime[0]
          params.enddate = this.submitTime[1]
        }

        const response = await getUserFeedBackList(params)
        if (response.code === 0 && response.page) {
          this.tableData = response.page.list || []
          this.totalCount = response.page.totalCount || 0
        } else {
          this.$message.error('获取数据失败')
        }
      } catch (error) {
        console.error('获取用户反馈列表失败：', error)
        this.$message.error('获取数据失败')
      } finally {
        this.listLoading = false
      }
    },
    /** 获取客户端类型 */
    async fetchClientTypes() {
      const { data } = await getClientType();
      console.log("获取客户端类型", data);
      this.clientTypes = data.data[0].children.map((item) => {
        return {
          label: item.dictValue,
          value: item.dictKey,
        };
      });
    },
    /** 获取问题类型列表 */
    async fetchEtList() {
      const { data } = await getEtList();
      console.log("获取问题类型列表", data);
      this.etList = data.data.list;
    },
    /** 获取版本列表 */
    async fetchVersionListByChanelid() {
      const { data } = await getVersionListByChanelid({ type: 2 });
      console.log("获取版本列表", data);
      this.versionList = data.list;
    },

    // 搜索
    handleSearch() {
      this.pageNo = 1
      this.getList()
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNo = 1
      this.getList()
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pageNo = val
      this.getList()
    },

    // 下载日志
    handleDownload(row) {
      if (row.logfileurl) {
        window.open(row.logfileurl, '_blank')
      } else {
        this.$message.warning('日志文件链接不存在')
      }
    },

    // 导出数据
    handleExport() {
      this.$message.info('导出功能待实现')
      // TODO: 实现导出功能
      console.log('导出参数：', this.searchForm)
    }
  }
}
</script>

<style scoped>
.ellipsis-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table_pagination {
  margin-top: 20px;
  text-align: right;
}
</style>